export enum OfferCoverageCode {
    OC = 'OC',
    OC_AMOUNT_OF_COVER = 'OC_AMOUNT_OF_COVER',
    OC_GREEN_CARD = 'OC_GREEN_CARD',
    OC_LIQUIDATION_OF_DAMAGE = 'OC_LIQUIDATION_OF_DAMAGE',
    NNW = 'NNW',
    NNW_DRIVER = 'NNW_DRIVER',
    NNW_PASSENGER = 'NNW_PASSENGER',
    ASSISTANCE = 'ASSISTANCE',
    ASSISTANCE_PACKAGE = 'ASSISTANCE_PACKAGE',
    ASSISTANCE_TERRITORIAL_SCOPE = 'ASSISTANCE_TERRITORIAL_SCOPE',
    ASSISTANCE_HAPPENING = 'ASSISTANCE_HAPPENING',
    ASSISTANCE_DISTANCE_HELP = 'ASSISTANCE_DISTANCE_HELP',
    ASSISTANCE_TOWING_ACCIDENT_PL = 'ASSISTANCE_TOWING_ACCIDENT_PL',
    ASSISTANCE_TOWING_BREAKDOWN_PL = 'ASSISTANCE_TOWING_BREAKDOWN_PL',
    ASSISTANCE_TOWING_EU = 'ASSISTANCE_TOWING_EU',
    ASSISTANCE_ACCIDENT_REPLACEMENT_CAR = 'ASSISTANCE_ACCIDENT_REPLACEMENT_CAR',
    ASSISTANCE_BREAKDOWN_REPLACEMENT_CAR = 'ASSISTANCE_BREAKDOWN_REPLACEMENT_CAR',
    ASSISTANCE_REPAIR_CAR = 'ASSISTANCE_REPAIR_CAR',
    ASSISTANCE_REPLACEMENT_OF_WHEELS = 'ASSISTANCE_REPLACEMENT_OF_WHEELS',
    ASSISTANCE_BATTERY = 'ASSISTANCE_BATTERY',
    ASSISTANCE_FUEL = 'ASSISTANCE_FUEL',
    ASSISTANCE_KEYS = 'ASSISTANCE_KEYS',
    AC_MINI = 'AC_MINI',
    AC_MINI_HAPPENING = 'AC_MINI_HAPPENING',
    AC = 'AC',
    AC_TYPE = 'AC_TYPE',
    AC_PRODUCT_NAME = 'AC_PRODUCT_NAME',
    AC_HAPPENING = 'AC_HAPPENING',
    AC_HAPPENING_ACCIDENT_AND_DAMAGE = 'AC_HAPPENING_ACCIDENT_AND_DAMAGE',
    AC_ELEMENTAL = 'AC_ELEMENTAL',
    AC_ANIMAL = 'AC_ANIMAL',
    AC_VEHICLE_THEFT = 'AC_VEHICLE_THEFT',
    AC_VALUE_OF_VEHICLE = 'AC_VALUE_OF_VEHICLE',
    AC_METHOD_VALUE_OF_VEHICLE = 'AC_METHOD_VALUE_OF_VEHICLE',
    AC_DEPRECATION = 'AC_DEPRECATION',
    AC_EXCESS = 'AC_EXCESS',
    AC_OWN_CONTRIBUTION = 'AC_OWN_CONTRIBUTION',
    AC_PARTS = 'AC_PARTS',
    AC_REPAIR_PLACE = 'AC_REPAIR_PLACE',
    AC_METHOD_OF_LIQUIDATION_OF_THE_DAMAGE = 'AC_METHOD_OF_LIQUIDATION_OF_THE_DAMAGE',
    AC_VALUE_OF_DETRIMENT = 'AC_VALUE_OF_DETRIMENT',
    OTHER_GLASS = 'OTHER_GLASS',
    OTHER_AID_PROGRAM = 'OTHER_AID_PROGRAM',
    OTHER_TIRES = 'OTHER_TIRES',
    OTHER_NEW_TIRES = 'OTHER_NEW_TIRES',
    OTHER_LUGGAGE = 'OTHER_LUGGAGE',
    OTHER_ADDITIONAL_EQUIPMENT = 'OTHER_ADDITIONAL_EQUIPMENT',
    OTHER_AC_NO_REDUCE = 'OTHER_AC_NO_REDUCE',
    OTHER_TPL = 'OTHER_TPL',
    OTHER_CHILD_SEAT = 'OTHER_CHILD_SEAT',
    DISCOUNT_TRAVEL_INSURANCE = 'DISCOUNT_TRAVEL_INSURANCE',
    DISCOUNT_TIRE_SERVICE = 'DISCOUNT_TIRE_SERVICE',
    DISCOUNT_PARTS = 'DISCOUNT_PARTS',
    DISCOUNT_REPAIRS = 'DISCOUNT_REPAIRS',
}

